import React from 'react';
import PropTypes from 'prop-types';

import { UserWrapper, UserName }  from './components';
import {ReactComponent as CloseIcon} from "../../../../img/dialog-close.svg";
import Icon from "../../Common/Icon";
import ConfigService from "../../../Services/api/Config";

const ChatUserSelected = ({ user, onClick }) => {
  return (
    <UserWrapper backgroundColor={ ConfigService.getColor('tertiaryColor')}>
      <UserName>
        {user.name}
      </UserName>
      <Icon
        width='7'
        height='7'
        color='primaryColor'
        onClick={() => onClick(user)}
      >
        <CloseIcon alt='icon-close'/>
      </Icon>
    </UserWrapper>
  )
};

ChatUserSelected.propTypes = {
  user: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

export default React.memo(ChatUserSelected);